<template>
  <div class="bg-gray-900">
    <div class="relative isolate px-6 pt-14 lg:px-8">
      <div class="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80" aria-hidden="true">
        <div class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]" style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)" />
      </div>
      
      <div class="mx-auto max-w-2xl py-32 sm:py-48 lg:py-24">
        <div class="hidden sm:mb-8 sm:flex sm:justify-center">
          <div class="relative rounded-full px-3 py-1 text-sm/6 text-gray-400 ring-1 ring-white/10 hover:ring-white/20">
            Join Our Charity Program. 
            <a href="#" @click.prevent="openModal" class="font-semibold text-indigo-400">
              <span class="absolute inset-0" aria-hidden="true"></span>Donate 
              <span aria-hidden="true">&rarr;</span>
            </a>
          </div>
        </div>

        <div class="text-center">
          <div class="flex justify-center">
            <img src="../../src/assets/logo-clean.png" alt="" width="50%">
          </div>
          
          <h1 class="text-balance text-5xl font-semibold tracking-tight text-white sm:text-7xl">The Developer team of your choice.</h1>
          <p class="mt-8 text-pretty text-lg font-medium text-gray-400 sm:text-xl/8">Creating Website, Mobile App, MultiLevel Marketing Platform, E-Commerce Platform, Portfolios, E-Learning Systems and CMS Platforms to suit your needs.</p>
          <div class="mt-10 flex items-center justify-center gap-x-6">
            <a href="#" class="rounded-md bg-indigo-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500">Get started</a>
            <a href="#" class="text-sm/6 font-semibold text-white">Learn more <span aria-hidden="true">→</span></a>
          </div>

          <div class="mt-8 sm:hidden flex justify-center">
            <div class="relative rounded-full px-3 py-1 text-sm/6 text-gray-400 ring-1 ring-white/10 hover:ring-white/20">
              Join Our Charity Program. 
              <a href="#" @click.prevent="openModal" class="font-semibold text-indigo-400">
                <span class="absolute inset-0" aria-hidden="true"></span>Donate 
                <span aria-hidden="true">&rarr;</span>
              </a>
            </div>
          </div>

        </div>
      </div>
      
      <div class="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]" aria-hidden="true">
        <div class="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]" style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)" />
      </div>
    </div>

    <div v-if="modalOpen" @click.self="closeModal" class="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center p-4 z-50 transition-opacity duration-300 ease-in-out">
      <div class="bg-gray-800 text-white rounded-xl shadow-2xl transform transition-transform duration-300 ease-in-out scale-95 opacity-0 w-full max-w-4xl max-h-[500px] overflow-y-auto" :class="{ 'scale-100 opacity-100': modalOpen }">
        <div class="p-8 flex flex-col md:flex-row gap-8">
          <div class="w-full md:w-1/2 flex flex-col items-center justify-center text-center">
            <div class="mb-4">
              <img src="../assets/sponsor.png" alt="Donation" class="rounded-lg shadow-lg max-w-full h-auto">
            </div>
            <h2 class="text-2xl font-semibold mb-2">Support Our Cause</h2>
            <p class="text-gray-300 text-left">
              Your donation is being used to the following programs. Indigent Student Programs - Designated to help struggling information technology students by providing them laptops. TESDA Certifcation Subsidy - Designated to help Senior High (TVET) and ALS Graduatees achieving a certification diploma, thus making it possible for them to join the workforce fair and square! Help us achieve our goal by donating even the lowest amount you could! Help these students that are struggling to achieve their dreams come true!
              <br>
              <br>
              When Donating Please Indicate on the Note: "Donation"
              Thank you.
            </p>
          </div>

          <div class="w-full md:w-1/2 relative min-h-[300px] flex flex-col items-center justify-center p-4 space-y-4">
            <h2 class="text-xl font-semibold text-white mb-4">Scan to Donate</h2>
            
            <div v-if="activeTab === 'gotyme'" class="w-full flex flex-col items-center justify-center transition-opacity duration-500 text-center">
              <img :src="gotyme_qr" alt="GoTyme QR" class="mx-auto rounded-md shadow-md mb-2 max-w-full h-auto">
            </div>
            
            <div v-else-if="activeTab === 'metrobank'" class="w-full flex flex-col items-center justify-center transition-opacity duration-500 text-center">
              <img :src="metrobank_qr" alt="MetroBank QR" class="mx-auto rounded-md shadow-md mb-2 max-w-full h-auto">
            </div>

            <div v-else-if="activeTab === 'palawanpay'" class="w-full flex flex-col items-center justify-center transition-opacity duration-500 text-center">
              <img :src="palawanpay_qr" alt="PalawanPay QR" class="mx-auto rounded-md shadow-md mb-2 max-w-full h-auto">
            </div>

            <div v-else-if="activeTab === 'seabank'" class="w-full flex flex-col items-center justify-center transition-opacity duration-500 text-center">
              <img :src="seabank_qr" alt="SeaBank QR" class="mx-auto rounded-md shadow-md mb-2 max-w-full h-auto">
            </div>

            <div v-else-if="activeTab === 'unionbank'" class="w-full flex flex-col items-center justify-center transition-opacity duration-500 text-center">
              <img :src="unionbank_qr" alt="UnionBank QR" class="mx-auto rounded-md shadow-md mb-2 max-w-full h-auto">
            </div>
            
            <div class="flex justify-center flex-wrap gap-2 mt-4">
              <button @click="activeTab = 'gotyme'"
                class="rounded-full px-4 py-2 text-sm font-semibold transition-colors"
                :class="{ 'bg-indigo-500 text-white': activeTab === 'gotyme', 'bg-gray-700 text-gray-300 hover:bg-gray-600': activeTab !== 'gotyme' }">
                GoTyme
              </button>
              <button @click="activeTab = 'metrobank'"
                class="rounded-full px-4 py-2 text-sm font-semibold transition-colors"
                :class="{ 'bg-indigo-500 text-white': activeTab === 'metrobank', 'bg-gray-700 text-gray-300 hover:bg-gray-600': activeTab !== 'metrobank' }">
                MetroBank
              </button>
              <button @click="activeTab = 'palawanpay'"
                class="rounded-full px-4 py-2 text-sm font-semibold transition-colors"
                :class="{ 'bg-indigo-500 text-white': activeTab === 'palawanpay', 'bg-gray-700 text-gray-300 hover:bg-gray-600': activeTab !== 'palawanpay' }">
                PalawanPay
              </button>
              <button @click="activeTab = 'seabank'"
                class="rounded-full px-4 py-2 text-sm font-semibold transition-colors"
                :class="{ 'bg-indigo-500 text-white': activeTab === 'seabank', 'bg-gray-700 text-gray-300 hover:bg-gray-600': activeTab !== 'seabank' }">
                SeaBank
              </button>
              <button @click="activeTab = 'unionbank'"
                class="rounded-full px-4 py-2 text-sm font-semibold transition-colors"
                :class="{ 'bg-indigo-500 text-white': activeTab === 'unionbank', 'bg-gray-700 text-gray-300 hover:bg-gray-600': activeTab !== 'unionbank' }">
                UnionBank
              </button>
            </div>
          </div>
        </div>
        <div class="flex justify-end p-4 border-t border-gray-700">
          <button @click="closeModal" class="rounded-lg bg-gray-700 px-4 py-2 text-sm font-semibold text-white hover:bg-gray-600 transition-colors">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import gotyme_qr from '@/assets/GoTyme.png';
import metrobank_qr from '@/assets/mb.png';
import palawanpay_qr from '@/assets/pp.png';
import seabank_qr from '@/assets/sb.png';
import unionbank_qr from '@/assets/ub.png';

const modalOpen = ref(false);

const openModal = () => {
  modalOpen.value = true;
};

const closeModal = () => {
  modalOpen.value = false;
};

const activeTab = ref('gotyme');

</script>

<style scoped>
/* Scoped styles for this component */
#app {
  font-family: 'Inter', sans-serif;
}
</style>